import ElectricType from "../foodType/ElectricType"
import TemperatureType from "../foodType/TemperatureType"
import PanType from "../foodType/PanType"
import CarrierType from "../foodType/CarrierType"

const foodFilterTypes = (filter) => {
  const types = {
    electricType: ElectricType,
    temperatureType: TemperatureType,
    panType: PanType,
    carrierType: CarrierType,
  }
  return types[filter]
}

export default foodFilterTypes
